import {
  Divider,
  Form,
  FormInstance,
  InputNumber,
  Radio,
  Space,
  Select,
} from "antd";

import { useAppSelector } from 'store';
import { citiesSelector } from 'store/dictionaries/dictionaries.selectors';

export const DisplaySettingsFields = ({ form, citiesDisabled }: { form: FormInstance, citiesDisabled?: boolean }) => {
  const { options: cities, loading: citiesLoading } = useAppSelector(citiesSelector);
  const age = Form.useWatch('age', form);
  return (
    <>
      <Divider plain>
        Сегментация аудитории
      </Divider>
      <Form.Item
        name="gender"
        label="По полу"
      >
        <Radio.Group>
          <Radio.Button value={null}>Любой</Radio.Button>
          <Radio.Button value="male">Мужской</Radio.Button>
          <Radio.Button value="female">Женский</Radio.Button>
        </Radio.Group>
      </Form.Item>

     <Form.Item
        validateTrigger={'onBlur'}
        label={'По возрасту'}
        name="age"
        dependencies={[
          ['age', 'from'],
          ['age', 'to'],
        ]}
        rules={[
          (form) => ({
            validator: (_, value = {}) => {
              const from = value?.from || '';
              const to = value?.to || '';
              if (from && to && from > to) {
                return Promise.reject('Значение "от" не может быть больше "до"');
              }
              return Promise.resolve();
            },
          }),
        ]}
      >
        <Form.Item noStyle>
          <Space direction={"horizontal"} split={<Divider type="vertical" />}>
            <Form.Item
              noStyle
              name={['age', 'from']}
            >
              <InputNumber
                addonBefore={'от'}
                min={0}
                max={99}
                step={1}
                precision={0}
              />
            </Form.Item>
            <Form.Item
              noStyle
              name={['age', 'to']}
            >
              <InputNumber
                addonBefore={'до'}
                min={age?.from}
                max={99}
                step={1}
                precision={0}
              />
            </Form.Item>
          </Space>
        </Form.Item>
      </Form.Item>
      <Form.Item
        label="Города"
        name="cityIds"
        // rules={[
        //   {
        //     required: true,
        //     message: 'Обязательное поле',
        //   },
        // ]}
      >
        <Select
          showSearch={false}
          disabled={citiesDisabled}
          placeholder="Выберите города"
          options={cities}
          loading={citiesLoading}
          mode="multiple"
        />
      </Form.Item>
    </>
  );
};
